import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'worslot-remove');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'work_slots',
    'removals',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/workslot-remove-req.js